import React from 'react';
import { Editor } from "@common/components/email-template/components/editor";
import { IInputComponent } from "@modules/fhq-design-tool/types/input-component";
import { Title } from '../title';

import './text-editor.styles.scss';

export type TextEditorProps = IInputComponent<string> & {
  label?: string;
};

export const TextEditor: React.FC<TextEditorProps> = (props) => {
  const { label, value, onChange, metadata, required } = props;

  const [localValue, setLocalValue] = React.useState<string>('');

  React.useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = React.useCallback((val: string) => {
    setLocalValue(val);
  }, []);

  const handleBlur = React.useCallback((val: string) => {
    const isEmpty = val === "<p></p>\n";

    onChange(isEmpty ? '' : val);
  }, [onChange]);

  return (
    <div className="FhqDesignToolTextEditor">
      {label && <Title margin="0 0 16px 0" text={<>{label}{required && <span className="FhqDesignToolTextEditor__required-mark">*</span>}</>} />}
      <Editor
        classes={{
          root: 'FhqDesignToolTextEditor__component',
          workAreaInternal: 'FhqDesignToolTextEditor__component__work-area',
          textarea: 'FhqDesignToolTextEditor__component__textarea',
        }}
        getId={{
          textArea: {
            description: metadata.description
          },
        }}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        toolbarCustomButtons={[]}
      />
    </div>
  );
};